module.exports = class VerticalResizableLayout extends Backbone.Marionette.Layout
    template: require('./templates/vertical_layout')

    events:
        "mousedown > .slider-wrapper": "onSliderMouseDown"

    ui:
        "header": ".header"
        "topPane": ".top-pane"
        "bottomPane": ".bottom-pane"
        "slider": ".slider-wrapper"

    regions:
        "header": ".header"
        "topPane": ".top-pane"
        "bottomPane": ".bottom-pane"

    onSliderMouseDown: (e) =>
        e.preventDefault()

        $('body').bind('mouseup', @onSliderMouseUp)
        $('body').bind('mousemove', @onMouseMove)

    onSliderMouseUp: (e) =>
        e.preventDefault()

        $('body').unbind('mouseup', @onSliderMouseUp)
        $('body').unbind('mousemove', @onMouseMove)

    onMouseMove: (e) =>
        e.preventDefault()

        @resize(@calculatePosition(e))

    calculatePosition: (e) =>
        elementOffset = @$el.offset()

        # Find position of the mouse pointer within the parent element.
        offset = if elementOffset.top > 0 then elementOffset.top else 0

        Math.max(20, e.pageY - offset)

    resize: (position) =>
        sliderOffset = @ui.slider.height()
        #console.log('height', position, sliderOffset, @ui.header.height())
        @ui.slider.css('top', "#{position}px")
        @ui.topPane.css('height', "#{position - sliderOffset  - @ui.header.height()}px")
        @ui.bottomPane.css('top', "#{position + sliderOffset}px")



// WEBPACK FOOTER //
// ./app/lib/common/resizable/VerticalResizableLayout.coffee